// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"79bb7929","513":"4c1f6183","703":"369bb368","787":"4237f611"}[chunkId] + ".chunk.js";
};